var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vxe-grid',{ref:"table",attrs:{"border":"","size":"small","resizable":"","row-id":"id","show-overflow":"","highlight-hover-row":"","seq-config":{
      startIndex: (_vm.tablePage.currentPage - 1) * _vm.tablePage.pageSize,
    },"pager-config":_vm.tablePage,"sort-config":{ trigger: 'cell' },"proxy-config":_vm.tableProxy,"columns":_vm.columns,"toolbar-config2":_vm.tableToolbar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }